import { ObjectId } from '../../../mongodb';
import { IidPrefix } from '../interfaces/IidPrefix';
import { ITag } from '../interfaces/tag';

const primaryColor = '#0077CF';

export class Tag implements IidPrefix {
  idPrefix = 'tag';
  _id: string;
  orgId: string;
  name: string;
  color: string;
  key: string;
  collection: string;
  value?: string;

  constructor(r?: ITag) {
    if (r) {
      this._id = r._id;
      this.orgId = r.orgId;
      this.name = r.name;
      this.color = r.color;
      this.collection = r.collection;
    }
    //generate mongo id if not defined
    if (!this._id) {
      this._id = ObjectId.createObjectId(this);
    }
  }
}

export const colorBackground: Record<ColorID, string> = {
  /*green */ '#ECF5E2': '#9bcba6',
  /*blue */ '#D9EBF8': '#68b0e5',
} as const;
export const colorIDs = ['#D9EBF8', '#ECF5E2'] as const;

type ColorID = (typeof colorIDs)[number];

export const defaultObjectColors = {
  crib: '#7FB83D',
  location: primaryColor,
  user: '#A288FF',
  item: primaryColor,
} as const;

export const defaultObjectIcons = {
  crib: 'my_location',
  location: 'corporate_fare',
  user: 'groups',
};
